// Cookie SSO partagé entre les sous-domaines *.peelo.io (dashboard, console, sandbox…).
// localStorage n'est PAS partagé entre sous-domaines : on dépose donc le token JWT de
// session dans un cookie du domaine parent pour que console.peelo.io puisse l'adopter
// sans redemander une connexion (et inversement).

const SSO_COOKIE = 'peelo_sso_token';
const MAX_AGE = 30 * 24 * 60 * 60; // aligné sur l'expiration du JWT (30 jours)

// En dev local (localhost) on ne peut pas poser un cookie .peelo.io : on omet le domaine.
const cookieDomain = () =>
  window.location.hostname.endsWith('peelo.io') ? ';domain=.peelo.io' : '';

export function setSsoCookie(token) {
  if (!token) return;
  document.cookie = `${SSO_COOKIE}=${encodeURIComponent(token)};path=/;max-age=${MAX_AGE}${cookieDomain()};secure;samesite=Lax`;
}

export function clearSsoCookie() {
  document.cookie = `${SSO_COOKIE}=;path=/;max-age=0${cookieDomain()}`;
}

// À utiliser sur 401 : n'efface le cookie SSO que s'il porte LE MÊME token que la
// session locale qui vient d'échouer. Un cookie différent (session plus récente posée
// par un autre sous-domaine, ex: console) est conservé pour être adopté au login.
export function clearSsoCookieIfOwn(failingToken) {
  const cookie = getSsoCookie();
  if (cookie && failingToken && cookie === failingToken) clearSsoCookie();
}

export function getSsoCookie() {
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + SSO_COOKIE + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

// Redépose le cookie à partir de la session localStorage existante — couvre les
// utilisateurs connectés AVANT l'introduction du SSO et les sessions créées hors Login
// (inscription, onboarding…).
export function syncSsoCookieFromStorage() {
  try {
    const stored = localStorage.getItem('user');
    if (!stored) return;
    const parsed = JSON.parse(stored);
    const token = parsed?.data?.token || parsed?.token;
    if (token) setSsoCookie(token);
  } catch (e) {
    /* session illisible : on ne bloque rien */
  }
}

// Décode le payload d'un JWT SANS vérification de signature : uniquement pour pré-remplir
// la session côté front ; la validité réelle est contrôlée par l'API à chaque requête (401 sinon).
export function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}
